export enum PermissionScope {
    EOL = 'EOL',
    EOLCT = 'EOLCT',
}
